export const ORDER_STOP_STATUSES = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  DONE_WITHOUT_MANIFEST: 'DONE_WITHOUT_MANIFEST',
  MANIFESTED: 'MANIFESTED',
};

export const ORDER_STOP_DONE_STATUSES = [
  ORDER_STOP_STATUSES.DONE,
  ORDER_STOP_STATUSES.DONE_WITHOUT_MANIFEST,
  ORDER_STOP_STATUSES.MANIFESTED,
];
